import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import styled, { css } from 'styled-components';
import { Box, Button, Text } from '@freenow/wave';
import { ClickableHeaderContent } from '../../ClickableHeaderContent';
export const ShowHideAnimationWrapper = styled.div `
    overflow: hidden;

    ${({ isOpen }) => css `
        max-height: ${isOpen ? 300 : 0}px;
        opacity: ${isOpen ? 1 : 0};
    `};
    transition:
        max-height 0.3s linear,
        opacity 0.3s linear;

    ${Button} {
        margin-top: 16px;
    }
`;
export const Details = ({ children, actionLabel, showMoreLabel }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(ClickableHeaderContent, { onClick: () => setIsOpen(!isOpen), detailsTitle: showMoreLabel, isOpen: isOpen }),
        React.createElement(ShowHideAnimationWrapper, { isOpen: isOpen },
            React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center" },
                React.createElement(Text, null, children),
                React.createElement(Button, { onClick: () => copy(children) }, actionLabel)))));
};
